import { BaseAPIState, Value } from '@philips-emr/tws-core';
import { EventData, EventListener } from '@philips-emr/tws-core/lib/component/event';
import { Mountable } from '@philips-emr/tws-core/lib/component/types';

export interface HpmsCustomCardEventArgs<T> {
  key: string;
  data: T;
}

export interface HpmsCustomCardMenuRenderEventArgs<T> extends HpmsCustomCardEventArgs<T> {
  shouldRender(render: boolean): void;
}

class HpmsCustomCardMenuRenderEvent<T> extends EventData<HpmsCustomCardType<T>> implements HpmsCustomCardMenuRenderEventArgs<T> {
  key: string;
  data: T;
  shouldRender: (render: boolean) => void;

  constructor({ key, data, shouldRender }: HpmsCustomCardMenuRenderEventArgs<T>) {
    super();

    this.key = key;
    this.data = data;
    this.shouldRender = shouldRender;
  }
}

class HpmsCustomCardMenuRenderEventListener<T> extends EventListener<HpmsCustomCardType<T>, HpmsCustomCardMenuRenderEvent<T>, HpmsCustomCardMenuRenderEventArgs<T>> {
  constructor() {
    super(HpmsCustomCardMenuRenderEvent);
  }
}

class HpmsCustomCardEvent<T> extends EventData<HpmsCustomCardType<T>> implements HpmsCustomCardEventArgs<T> {
  key: string;
  data: T;

  constructor({ key, data }: HpmsCustomCardEventArgs<T>) {
    super();

    this.key = key;
    this.data = data;
  }
}

class HpmsCustomCardEventListener<T> extends EventListener<HpmsCustomCardType<T>, HpmsCustomCardEvent<T>, HpmsCustomCardEventArgs<T>> {
  constructor() {
    super(HpmsCustomCardEvent);
  }
}

interface HpmsCustomCardAPIState extends BaseAPIState {
  editing: boolean;
  data: Record<string, Value>;
  background: string;
}

export default interface HpmsCustomCardType<T> extends Mountable {

  /** @event */
  onCreateOption: HpmsCustomCardMenuRenderEventListener<T>;

  /** @event */
  onOptionClick: HpmsCustomCardEventListener<T>;
}

export {
  HpmsCustomCardAPIState,
  HpmsCustomCardMenuRenderEvent,
  HpmsCustomCardMenuRenderEventListener,
  HpmsCustomCardEvent,
  HpmsCustomCardEventListener,
};
